import {useCallback} from 'react';

import {REQUEST_CARD_EVENTS} from '@/app/auth/events/RequestCardEvents';
import {useTrackingManager} from '@/hooks';
import {IEventBaseDataSchema} from '@/services';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackSelectRequestPhysicalCard = useCallback(
    (baseSchema: IEventBaseDataSchema) => {
      trackEvent(
        REQUEST_CARD_EVENTS.SELECT_REQUEST_PHYSICAL_CARD_WITH_TEEN_DATA_SCHEDULE,
        {
          ...baseSchema,
        },
      );
    },
    [trackEvent],
  );

  const trackSelectRequestChangeShippingAddress = useCallback(
    (baseSchema: IEventBaseDataSchema) => {
      trackEvent(REQUEST_CARD_EVENTS.SELECT_REQUEST_ADDRESS_CHANGE, {
        ...baseSchema,
      });
    },
    [trackEvent],
  );

  return {
    trackSelectRequestPhysicalCard,
    trackSelectRequestChangeShippingAddress,
  };
};
